import { createContext, ReactNode } from 'react';

import { AccountStatus } from 'dashboard/models/account-status';
import { AccountType } from 'dashboard/models/account-type';
import { Environment } from 'dashboard/models/environment';
import { Graph } from 'dashboard/models/graph';
import { GraphQueryTemplate } from 'dashboard/models/graph-query-template';
import { User } from 'dashboard/models/user';

interface GraphDataContext {
  accountStatuses: AccountStatus[];
  accountTypes: AccountType[];
  currentEnvironment: Environment;
  currentUser: User;
  graph: Graph;
  graphQueryTemplates: GraphQueryTemplate[];
}

export const GraphDataContext = createContext<Partial<GraphDataContext>>({
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  accountStatuses: null,
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  accountTypes: null,
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  currentEnvironment: null,
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  currentUser: null,
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  graph: null,
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  graphQueryTemplates: null,
});

interface GraphDataWrapperProps {
  accountStatuses: AccountStatus[];
  accountTypes: AccountType[];
  currentEnvironment: Environment;
  currentUser: User;
  graph: Graph;
  graphQueryTemplates: GraphQueryTemplate[];
  children: ReactNode;
}

const GraphDataWrapper = (props: GraphDataWrapperProps) => {
  // For now we bind our context to these values that are passed in since that data is fetched
  // by a parent component.
  // TODO: GraphDataWrapper can fetch it's own data and manage it on it's own.
  const value = {
    accountStatuses: props.accountStatuses,
    accountTypes: props.accountTypes,
    currentUser: props.currentUser,
    currentEnvironment: props.currentEnvironment,
    graph: props.graph,
    graphQueryTemplates: props.graphQueryTemplates,
  };

  return <GraphDataContext.Provider value={value}>{props.children}</GraphDataContext.Provider>;
};

export default GraphDataWrapper;
